import React, { createContext, useContext, ReactNode } from "react";
import { EditorAdapter } from "./types";

const EditorContext = createContext<EditorAdapter | null>(null);

export function EditorProvider({
	adapter,
	children,
}: {
	adapter: EditorAdapter;
	children: ReactNode;
}) {
	return <EditorContext.Provider value={adapter}>{children}</EditorContext.Provider>;
}

export function useEditor(): EditorAdapter {
	const ctx = useContext(EditorContext);
	if (!ctx) {
		throw new Error("useEditor must be used within an EditorProvider");
	}
	return ctx;
}
